import styled from 'styled-components'

export const ColorPickerContainer = styled.div`
  position: relative;

  .swatch {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    border: 3px solid #fff;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .popover {
    position: absolute;
    top: calc(100% + 4px);
    transform: none;
    z-index: 999;
    border-radius: 9px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    background: white;
    padding: 12px;
  }
`
